import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiTableRow']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    borderColor: theme.vars.palette.grey[200],
  }),
};

const MuiTableRow: Components<CssVarsTheme>['MuiTableRow'] = {
  styleOverrides,
};

export default MuiTableRow;
